import template from './views/login.html';
import './login.scss';
import controller from './controllers/loginController';
import authSrv from './services/authService';



//import loginSrv from './services/loginService'
var name = "login"
var module = angular.module('app.LoginModule', [
        //import modules

    ])
    .component(name, {
        template: template,
        controller: controller,
        controllerAs: name,
    });

//module.service('authService', authSrv);
//module.service('loginService', loginSrv);
/* module.config(function($stateProvider, $urlRouterProvider) {
    "ngInject";

    $stateProvider
        .state('login', {
            url: '/login',
            views: {
                '@': {
                    template: loginTpl,
                    controller: loginCtrl,
                    controllerAs: 'login'
                }
            }
        })

}); */



// export this module
export default module;


// WEBPACK FOOTER //
// ./src/app/login/loginModule.js